module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAIJJREFUOBFjYBgF0BBgBNEVFRW3gJQqVIxS6nZHR4capYbQXz84KJCtrays3Pr//38vZDFGRsZt7e3t3iAxQvIwfUwwBoxGNxQkjiyGzManB8NgmGJK6VGD4SE4DIIClGbh/kEwtiKYxLFY0JXBMgK6OKn8YRDGhLxMrTggZM8wkgcAzaMm9ZNFuScAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighTop_disabled.png
// module id = 321
// module chunks = 0